import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";
import moment from "moment";
export const importantDocCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Birth Certificate": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Social Security Cards": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    Passport: [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Driver License": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Marriage Certificate": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Military Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Living Will Important Document Storage": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Living Trust": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Power Of Attorney Important Document Storage": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Insurance Policy": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Vehicle Titles Important Document Storage": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Educational Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Vaccination Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document ",
        dataIndex: "Who's Document ",
        key: "whosdocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
  };
};
